<h4 mat-dialog-title>Desistement sur le dossier {{data.numeroDossier}}</h4>
<mat-dialog-content>
  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label>Date du désistement</mat-label>
        <input matInput
          class="w-20"
          type="date"
          [(ngModel)]="dateDesistement"
          >
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col">
        Commentaire : <textarea style="width:100%" [rows]="5" [(ngModel)]="commentaire"></textarea>
      </div>
    </div>

    @if (errors.length>0) {
      <div class="row alert alert-danger mt-1">
        <div class="col">
          <p>Avant de valider : </p>
          @for (error of errors; track error) {
            <p> - {{error}} </p>
          }
        </div>
      </div>
    }

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false">{{'general.annuler' |translate}}</button>
    <button mat-raised-button color="primary" (click)="saveDesistement()" [disabled]="commentaire.trim().length === 0 || dateDesistement === null">{{'general.valider' |translate}}</button>
  </mat-dialog-actions>
